export default "__VITE_ASSET__DciCBIba__"